export const styles = {
  container: {
    width: '310px',
    height: '146px',
    background: '#FFFFFF',
    padding: '16px 16px 24px 16px',
    borderRadius: '8px',
    boxShadow: '0px 2px 14px 0px rgba(39, 55, 84, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '100%',
  },
  text: {
    display: 'block',
    paddingRight: '20px',
    height: '80%',
  },
  title: {
    fontSize: '18px',
    fontWeight: 700,
    marginBottom: 10,
    lineHeight: '20px',
    color: '#2E3860',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#0C172CC',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '40px',
    borderRadius: '12px',
    border: '1px solid #273754',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 700,
    background: '#FFFFFF',
    cursor: 'pointer',
    '&:hover': {
      color: '#FFFFFF',
      background: '#004360',
      border: `1px solid #004360`,
    },
    '&:active': {
      color: '#FFFFFF',
      background: '#D72B4F',
      border: `1px solid #D72B4F`,
    },
  },
  icon: {
    display: 'flex',
    width: '32px',
    height: '32px',
  },
}
